<template>
  <div class="all_body">
    <div class="buy_d">
      <div class="buy_d_left">
        <div class="buy_d_left_title">蛋鸡供应链SAAS系统</div>
        <div class="buy_d_left_buttons">
          <div class="buy_d_left_button_1">产品介绍</div>
          <div class="buy_d_left_button_2">功能清单</div>
          <div class="buy_d_left_button_2">客户案例</div>
        </div>
        <div class="buy_d_content_1">成长性的蛋鸡养殖管理系统、敏捷应用、极简界面、精细化管理、产业链协同</div>
        <div class="buy_d_left_bottom">
          <div>基础设置： 仓库设置、出入库类别、采购模式、销售模式、集团级内部采销模式</div>
          <div>期初设置： 期初数据一键导入</div>
          <div>功能操作： 采购入库、自产入库、销售发货、自产领用、往来调拨</div>
          <div>业务报表： 现存量表： 一目了然查看库存</div>
          <div class="buy_d_left_bottom_kong">库存台账： 对每笔出入库记录详细追踪</div>
          <div class="buy_d_left_bottom_kong">收发存汇总表： 一键总览按照各种维度的库存收发汇总数据</div>
        </div>
      </div>
      <div class="buy_d_right">
        <div class="buy_d_right_1">
          <div class="buy_d_right_title">组织信息填写</div>
          <el-form ref="form" :model="form" :rules="rules" label-position="left" label-suffix=":">
            <el-form-item label="集团名称" prop="group_name">
              <el-input v-model="form.group_name" placeholder="请完整输入集团名称"></el-input>
            </el-form-item>
            <el-form-item label="联系人" prop="user_name">
              <el-input v-model="form.user_name" placeholder="请输入联系人姓名"></el-input>
            </el-form-item>
            <el-form-item label="联系方式" prop="phone">
              <el-input v-model="form.phone" placeholder="请输入电话号码"></el-input>
            </el-form-item>
            <el-form-item label="地址信息" prop="address">
              <el-input v-model="form.address" placeholder="请输入完整地址信息"></el-input>
            </el-form-item>

            <div class="buy_d_year">购买年限</div>
            <div class="buy_d_year_content">
              <div
                class="buy_d_year_content_one buy_d_h"
                :class="{'buy_d_active':active === 1}"
                @click="getbuyyear(1)"
              >1年</div>
              <div
                class="buy_d_year_content_two buy_d_h"
                :class="{'buy_d_active':active === 2}"
                @click="getbuyyear(2)"
              >2年</div>
              <div
                class="buy_d_year_content_two buy_d_h"
                :class="{'buy_d_active':active === 3}"
                @click="getbuyyear(3)"
              >3年</div>
            </div>
            <div class="buy_d_total">总额</div>
            <div class="buy_d_total_money">
              <span class="buy_d_total_money_1">￥</span>
              <span class="buy_d_total_money_2">{{form.payment_amount}}</span>
              <span class="buy_d_total_money_3">元</span>
            </div>
            <div class="buy_d_type">付费类型</div>
            <el-form-item label prop="order_type">
              <el-radio-group v-model="form.order_type">
                <el-radio label="0">个人账户打款</el-radio>
                <el-radio label="1">企业账户打款</el-radio>
              </el-radio-group>
            </el-form-item>

            <div class="buy_d_remarks">
              <div>注：</div>
              <div>选择企业账户打款时，所填集团/公司名称将成为提供发票的依据</div>
            </div>
          </el-form>
        </div>
        <div class="buy_d_submit" @click="onSubmit">立即购买</div>
      </div>
    </div>
  </div>
</template>

<script>
import { placeOrder, getPriceByType } from "../../api/api";
export default {
  name: "Buy_d",
  data() {
    return {
      sypt: "./static/img/sypt.png",
      yypt: "./static/img/yypt.png",
      glpt: "./static/img/gjpt.png",
      gzpt: "./static/img/gzpt.png",
      active: 1,
      yearlist:[],
      form: {
        ticket: "",
        group_name: "",
        user_name: "",
        phone: "",
        address: "",
        years_purchase: 1,
        payment_amount: "",
        package_type: 3,
        order_type: ""
      },
      rules: {
        group_name: [
          { required: true, message: "集团名称不能为空", trigger: "blur" }
        ],
        user_name: [
          { required: true, message: "联系人不能为空", trigger: "blur" }
        ],
        phone: [
          { required: true, message: "联系方式不能为空", trigger: "blur" }
        ],
        address: [
          { required: true, message: "地址信息不能为空", trigger: "blur" }
        ],
        order_type: [
          { required: true, message: "付费类型不能为空", trigger: "blur" }
        ]
      }
    };
  },
  mounted() {
    this.$store.commit("settab", 6);
    this.getPriceByTypes(); 
  },
  methods: {
    getbuyyear(e) {
      this.active = e;
      this.form.years_purchase = e;
      for (var i in this.yearlist) {
        if(this.yearlist[i].year == this.form.years_purchase){
            this.form.payment_amount = this.yearlist[i].price
        }
      }
    },
    getPriceByTypes(){
      getPriceByType({
            ticket : localStorage.getItem('ticket'),
            type : 3
        }).then(res => {
          this.yearlist = res.data;
            for (var i in res.data) {
              console.log(res.data[i].year,this.form.years_purchase)
              if(res.data[i].year == this.form.years_purchase){
                  this.form.payment_amount = res.data[i].price
              }
            }
            console.log(res)
        })
    },
    onSubmit() {
      this.form.ticket = localStorage.getItem('ticket')
      this.$refs["form"].validate(valid => {
        if (valid) {
            placeOrder(this.form).then(res => {
              if(res.code === "2000"){
                  this.$router.push('/Buy_info/'+ res.data.order_id)
                  return false;
              }else{
                this.$message.error(res.msg)
              }
            });
        }
      })
    }
  }
};
</script>

<style>
.all_body {
  width: 100%;
  padding-left: 11%;
  padding-right: 10%;
}
.buy_d {
  margin-top: 30px;
  width: 100%;
  /* width: 1479px; */
  height: 1200px;
  margin-bottom: 2px;
  background: url("~@/assets/2-4.png") no-repeat center center;
  z-index: -10;
  zoom: 1;
  background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
  background-position: center 0;
  display: flex;
  margin-bottom: 50px;
}
.buy_d_left {
  margin-left: 94px;
  margin-top: 200px;
}
.buy_d_left_title {
  font-size: 36px;
  font-weight: 500;
  color: #adff2b;
  letter-spacing: 5px;
}
.buy_d_left_buttons {
  margin-top: 52px;
  display: flex;
}
.buy_d_left_button_1 {
  width: 100px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background: #55b233;
  border-radius: 6px;
  font-size: 18px;
  color: #ffffff;
  letter-spacing: 2px;
}
.buy_d_left_button_2 {
  width: 100px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background: #55b233;
  border-radius: 6px;
  font-size: 18px;
  color: #ffffff;
  margin-left: 96px;
}
.buy_d_content_1 {
  width: 580px;
  height: 53px;
  line-height: 53px;
  letter-spacing: 1px;
  margin-top: 120px;
  font-size: 24px;
  color: #ffffff;
}
.buy_d_left_bottom {
  margin-top: 120px;
  font-size: 16px;
  color: #ffffff;
  width: 600px;
  height: 166px;
  line-height: 30px;
}
.buy_d_left_bottom_kong {
  margin-left: 84px;
}
.buy_d_right {
  margin-top: 62px;
  width: 550px;
  height: 1000px;
  background: #ffffff;
  border-radius: 10px;
  opacity: 0.9;
  margin-left: 220px;
  /* margin-right: 60px; */
}
.buy_d_right_1 {
  margin-left: 27px;
}
.buy_d_right_title {
  margin-top: 25px;
  font-size: 20px;
  font-weight: 400;
  line-height: 50px;
  color: #000000;
}
.buy_d_right .el-form {
  margin-top: 21px;
}
.buy_d_right .el-form-item {
  display: flex;
}
.buy_d_right .el-form--label-left .el-form-item__label{
  width: 110px;
}
.buy_d_right .el-form-item__label {
  width: 110px;
  font-size: 18px;
  color: #343434;
}
.buy_d_right .el-input {
  width: 390px;
  height: 46px;
  /* border: 1px solid #C0C0C0; */
}
.buy_d_right .el-input__inner:focus {
  border-color: #56b234;
}
.buy_d_year {
  margin-top: 20px;
  font-size: 20px;
  color: #000000;
}
.buy_d_year_content {
  display: flex;
  margin-top: 40px;
}
.buy_d_year_content_one {
  width: 150px;
  height: 100px;
  line-height: 100px;
  text-align: center;
  background: #f7f7f7;
  font-size: 20px;
  color: #000000;
  letter-spacing: 2px;
  cursor: pointer;
}
.buy_d_year_content_two {
  margin-left: 19px;
  width: 150px;
  height: 100px;
  line-height: 100px;
  text-align: center;
  background: #f7f7f7;
  font-size: 20px;
  color: #000000;
  letter-spacing: 2px;
  cursor: pointer;
}
.buy_d_active {
  background: #56b234;
  color: #ffffff;
}
.buy_d_h:hover {
  border: 1px dashed #56b234;
}
.buy_d_total {
  margin-top: 54px;
  font-size: 20px;
  font-weight: 400;
  color: #000000;
  line-height: 50px;
}
.buy_d_total_money {
  margin-left: 39px;
  margin-top: 22px;
}
.buy_d_total_money_1 {
  font-size: 30px;
}
.buy_d_total_money_2 {
  font-size: 40px;
  padding-left: 10px;
  font-weight: 500;
}
.buy_d_total_money_3 {
  font-size: 20px;
  padding-left: 20px;
}
.buy_d_type {
  margin-top: 44px;
  font-size: 20px;
  font-weight: 400;
  color: #000000;
}
.buy_d_right .el-radio-group {
  margin-top: 40px;
  margin-left: 40px;
}
.buy_d_right .el-radio__label {
  font-size: 16px;
  color: #060001;
}
.buy_d_right .el-radio__input {
  width: 16px;
  height: 16px;
}
.buy_d_right .el-radio__input.is-checked .el-radio__inner {
  border-color: #56b234;
  background: #56b234;
}
.buy_d_right .el-radio__input.is-checked + .el-radio__label {
  color: #56b234;
}
.buy_d_remarks {
  display: flex;
  width: 480px;
  margin-top: 20px;
  font-size: 16px;
  letter-spacing: 1px;
  color: #000000;
  font-weight: 400;
  margin-bottom: 21px;
}
.buy_d_submit {
  width: 400px;
  height: 44px;
  line-height: 44px;
  background: #56b234;
  border-radius: 6px;
  margin: 0 auto;
  font-size: 20px;
  color: #ffffff;
  text-align: center;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/views/sys/buy_d.vue